<template>
  <article class="layout-section -bg-primary -alt-top">
    <div class="layout-section__hgroup">
      <h2 class="layout-section__title">{{ wp.research.title }}</h2>
    </div>

    <section class="card-article">
      <article v-for="entry in wp.research.members" :key="entry.name" class="card-article__item">
        <figure class="card-article__figure" :style="getImageUrl(entry)" />

        <section class="card-article__content">
          <h3 class="card-article__title">{{ entry.name }}</h3>
          <p class="card-article__subtitle">{{ entry.position }}</p>
          <a v-if="entry.email" :href="`mailto:${entry.email}`" class="link card__cta -alt">{{ entry.email }}</a>
        </section>
      </article>
    </section>
  </article>
</template>

<script>
export default {
  name: 'AboutTeamIndexMore',
  inject: ['wp'],
  methods: {
    getImageUrl({ image }) {
      return { backgroundImage: image ? `url(${image})` : 'url(/images/brand/placeholder.png)' }
    }
  }
}
</script>
